import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  GetAllEmployees,
  getGPUbySn,
  FailGpuApi,
  PrintRMACodeApi,
  PrintRMAIDApi,
} from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { useStateContext } from "../../contexts/ContextProvider";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import DateTimeField from "../../components/DateTimeField";

const GpuRMA = () => {
  const navigate = useNavigate();
  const { userID } = useStateContext();
  const [getEmployees, setEmployees] = useState([]);
  const [snList, setSnList] = useState([]);
  const [formData, setFormData] = useState({
    gpu_id: 0,
    so_id: "",
    f_gpu_sn: "",
    part: "",
    gpu_name: "",
    specs: "",
    sku: "",
    box_id: "",
    lot_no: "",
    recv_date: "",
    test_date: "",
    employee: "Select Employee",
    note: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "f_gpu_sn") {
      if (value.length > 10 && value.length < 18) {
        await getGPUbySn(value)
          .then((resp) => {
            if (resp?.data?.status_id === 13) {
              setFormData((prev) => ({
                ...prev,
                gpu_id: resp.data.gpu_id,
                so_id: resp.data.so_id,
                f_gpu_sn: resp.data.gpu_sn,
                part: `${resp.data.part_number} - ${resp.data.part_description}`,
                gpu_name: resp.data.name,
                specs: resp.data.specs,
                sku: resp.data.sku,
                box_id: resp.data.box_id,
                lot_no: resp.data.lot_no,
                recv_date: resp.data.recv_scan_date.slice(0, -1),
                test_date: resp.data.test_scan_date.slice(0, -1),
              }));
            } else
              setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
          })
          .catch((err) => console.log(err.message));
      } else setFormData((prev) => ({ ...prev, [name]: value, gpu_id: 0 }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleNext = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    if (snList.some((item) => item.gpu_sn === formData.f_gpu_sn)) {
      showErrorToast("Duplicate GPU SN!", "This GPU SN already exists!");
      setLoadBtn(false);
      return;
    }
    setSnList((prev) => [
      ...prev,
      {
        gpu_id: formData.gpu_id,
        gpu_sn: formData.f_gpu_sn,
        note: formData.note,
      },
    ]);
    setFormData((prev) => ({ ...prev, gpu_id: 0, f_gpu_sn: "", note: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    var gpus = [];
    var gsns = [];
    var nott = [];
    for (const sn of snList) {
      gpus.push(sn.gpu_id);
      gsns.push(sn.gpu_sn);
      nott.push(sn.note);
    }
    if (formData.gpu_id && !gsns.some((item) => item === formData.f_gpu_sn)) {
      gpus.push(formData.gpu_id);
      gsns.push(formData.f_gpu_sn);
      nott.push(formData.note);
    }
    const gpuStr = gsns.join("|");
    const reqData = {
      user_id: userID,
      employee_id: formData.employee.value,
      datetime: null,
      gpu_id: gpus,
      notes: nott,
    };
    try {
      const res = await FailGpuApi(reqData);
      if (res.success) {
        await PrintRMACodeApi(gpuStr);
        await PrintRMAIDApi(gpuStr);
        showSuccessToast("Success!", "GPUs RMA created successfully!");
        navigate("/GpuWb");
      } else
        showErrorToast("Error!", "GPUs RMA failed to create!\n" + res.message);
    } catch (err) {
      showErrorToast("Error!", "GPUs RMA did not create!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      TimeoutUtility.resetTimeout();
      await GetAllEmployees()
        .then((resp) => {
          const employeeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.employee_id,
          }));
          setEmployees(employeeOptions || []);
        })
        .catch((err) => console.log(err.message));
    }
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="FAILED GPU RMA" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={5} lg={6} className="container-col">
              <div className="col-lg-12">
                <SelectField
                  label="RMA Operator:"
                  name="employee"
                  value={formData.employee}
                  options={getEmployees}
                  onChange={handleSelectChange}
                  placeholder="Operator"
                  compulsory={true}
                  error={errors.employee}
                />
                <TextInputField
                  label="Failed GPU SN Scan:"
                  name="f_gpu_sn"
                  value={formData.f_gpu_sn}
                  onChange={handleChange}
                  placeholder="GPU SN"
                  error={errors.f_gpu_sn}
                  compulsory={true}
                />
                <TextAreaField
                  label="Note:"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  placeholder="Note"
                  error={errors.note}
                  disabled={!formData.gpu_id}
                />
                <Button
                  margin="10px"
                  padding="20px"
                  text="Next"
                  onClick={handleNext}
                  disabled={loadBtn}
                />
              </div>
            </Col>
            <Col xl={5} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="SO:"
                  name="so_id"
                  value={formData.so_id}
                  placeholder="SO"
                  disabled
                />
                <TextInputField
                  label="Part:"
                  name="part"
                  value={formData.part}
                  placeholder="Part"
                  disabled
                />
                <TextInputField
                  label="Name:"
                  name="gpu_name"
                  value={formData.gpu_name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Specs:"
                  name="specs"
                  value={formData.specs}
                  placeholder="Specs"
                  disabled
                />
                <TextInputField
                  label="SKU:"
                  name="sku"
                  value={formData.sku}
                  placeholder="SKU"
                  disabled
                />
                <TextInputField
                  label="Box ID:"
                  name="box_id"
                  value={formData.box_id}
                  placeholder="Box ID"
                  disabled
                />
                <TextInputField
                  label="Lot #:"
                  name="lot_no"
                  value={formData.lot_no}
                  placeholder="Lot #"
                  disabled
                />
                <DateTimeField
                  label="Recv Datetime:"
                  name="recv_date"
                  value={formData.recv_date}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
                <DateTimeField
                  label="Last Test Datetime:"
                  name="test_date"
                  value={formData.test_date}
                  placeholder="DateTime"
                  now={false}
                  formField={true}
                  disabled
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update All & Print"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default GpuRMA;
